import { useState } from "react";
import { Col, Row } from "react-bootstrap";

function FaqItem(props: any) {
    const [param, setParam] = useState(props);
    
    const setOpen = (isOpen: boolean)=>{
        let p = {...param, isOpen: !isOpen};
        setParam(p);
    }

    return <div className="faq-item">
        <Row>
            <Col xs={2} md={1} sm={1}><p className="faq-id">{param.id} .</p></Col>
            <Col xs={10} md={11} sm={10.5}>
                <div>
                    <Row className="faq-title-block" onClick={()=>setOpen(param.isOpen)}>
                        <Col xs={11} className="p-0"><p className="faq-title">{param.title}</p></Col>
                        <Col xs={1} className="faq-close">
                            <span className="faq-wrap-icon">{param.isOpen ? '_' : '+'}</span>
                        </Col>
                    </Row>
                    {
                        param.isOpen && 
                        <Row>
                            <Col className="p-0">
                                <p className="faq-answer">
                                    {param.answer}
                                </p>
                            </Col>
                        </Row>
                    }
                </div>
            </Col>
        </Row>
    </div>
}

export default FaqItem;